module.exports = __webpack_public_path__ + "img/bb0110e.jpg";